import { render, staticRenderFns } from "./functional-areas.vue?vue&type=template&id=0de7e6ff&"
import script from "./functional-areas.vue?vue&type=script&lang=js&"
export * from "./functional-areas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "functional-areas.vue"
export default component.exports